import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {FaultSyncState} from '@docma-mm-core/fault/fault-sync-state';
import {SyncStatusEnum} from '@docma-mm-core/model/sync-state/sync-status.enum';

@Component({
  selector: 'mydocma-mm-sync-status-cell-renderer',
  templateUrl: './sync-status-cell-renderer.component.html',
  styleUrls: ['./sync-status-cell-renderer.component.scss']
})
export class SyncStatusCellRendererComponent implements OnInit {

  params: ICellRendererParams;
  value: SyncStatusEnum;

  public syncStatus = SyncStatusEnum;

  constructor() { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = (this.params.data as FaultSyncState).SyncStatus
  }

  refresh(params: any): boolean {
    this.params = params;
    this.value = (this.params.data as FaultSyncState).SyncStatus
    return true;
  }
}
